// extracted by mini-css-extract-plugin
export var grid = "_1u-0";
export var span1 = "_1u-2";
export var span10 = "_1u-b";
export var span10L = "_1u-z";
export var span10M = "_1u-n";
export var span10Xl = "_1u-1b";
export var span11 = "_1u-c";
export var span11L = "_1u-10";
export var span11M = "_1u-o";
export var span11Xl = "_1u-1c";
export var span12 = "_1u-d";
export var span12L = "_1u-11";
export var span12M = "_1u-p";
export var span12Xl = "_1u-1d";
export var span1L = "_1u-q";
export var span1M = "_1u-e";
export var span1Xl = "_1u-12";
export var span2 = "_1u-3";
export var span2L = "_1u-r";
export var span2M = "_1u-f";
export var span2Xl = "_1u-13";
export var span3 = "_1u-4";
export var span3L = "_1u-s";
export var span3M = "_1u-g";
export var span3Xl = "_1u-14";
export var span4 = "_1u-5";
export var span4L = "_1u-t";
export var span4M = "_1u-h";
export var span4Xl = "_1u-15";
export var span5 = "_1u-6";
export var span5L = "_1u-u";
export var span5M = "_1u-i";
export var span5Xl = "_1u-16";
export var span6 = "_1u-7";
export var span6L = "_1u-v";
export var span6M = "_1u-j";
export var span6Xl = "_1u-17";
export var span7 = "_1u-8";
export var span7L = "_1u-w";
export var span7M = "_1u-k";
export var span7Xl = "_1u-18";
export var span8 = "_1u-9";
export var span8L = "_1u-x";
export var span8M = "_1u-l";
export var span8Xl = "_1u-19";
export var span9 = "_1u-a";
export var span9L = "_1u-y";
export var span9M = "_1u-m";
export var span9Xl = "_1u-1a";
export var stretch = "_1u-1";